import { Component } from "@angular/core";
import { ModalController } from "@ionic/angular";
import { RideOpsUiService } from "source/app/configuration/services/rideops-ui.service";
import { CloseLocationComponent } from "../close-location/close-location.component";

@Component({
	selector: "app-closing-time-reminder",
	templateUrl: "./closing-time-reminder.component.html",
	styleUrls: ["./closing-time-reminder.component.scss"],
})
export class ClosingTimeReminderComponent {
	static modalId = "closing-time-reminder-component";

	constructor(
		private modalController: ModalController,
		public rideOpsUi: RideOpsUiService,
	) {}

	async goToCloseLocation() {
		await this.modalController.dismiss();
		const closeModal = await this.modalController.create({
			component: CloseLocationComponent,
			cssClass: "close-location-modal auto-height",
		});

		await closeModal.present();
	}

	async dismiss() {
		await this.modalController.dismiss();
	}
}
